import React from "react";

import { Result, Button } from "antd";

import logout from "../../api/logout";

import { signOut } from "../../utils/common";

import "./UnderMaintenance.css";

const statusMap = {
  403: {
    status: "403",
    title: "Access denied",
    subTitle: "Sorry, you are not authorized to access this page.",
  },
  404: {
    status: "404",
    title: "Page not found",
    subTitle: "Sorry, the page you visited does not exist.",
  },
  500: {
    status: "500",
    title: "Something went wrong.",
    subTitle: "Sorry, something went wrong.",
  },
};

const UnderMaintenance = ({ history, statusCode = 500 }) => {
  const navigateToHome = () => {
    window.location.href = "/";
  };

  const handleLogout = () => {
    logout().catch(() => {
      // Silently handle errors - will still clear storage
    });
    signOut(history, null);
  };

  const content = statusMap[statusCode] || statusMap[500];

  return (
    <div className="UnderMaintenanceContainer">
      <Result
        status={content.status}
        title={content.title}
        subTitle={content.subTitle}
        extra={[
          <Button key="home" type="primary" onClick={navigateToHome}>
            Back To Home
          </Button>,
          <Button key="logout" onClick={handleLogout}>
            Sign Out
          </Button>,
        ]}
      />
    </div>
  );
};

export default UnderMaintenance;
